export enum FilterMode {
  MULTIPLE_FILTER = 1,
  SINGLE_FILTER = 2,
}
